'use client'

import { useEffect, useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { motion, AnimatePresence } from 'framer-motion'

const links = [
  { href: '#how', label: 'How it works' },
  { href: '#calculator', label: 'Calculator' },
  { href: '#assets', label: 'Assets' },
  { href: '#security', label: 'Security' },
  { href: '#faq', label: 'FAQ' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-ink/80 backdrop-blur-xl border-b border-steel-700/40'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-18 flex items-center justify-between py-3">
        <Link href="/" className="flex items-center gap-3 group">
          <div className="relative h-11 w-11 shrink-0 rounded-xl overflow-hidden ring-1 ring-electric-500/30 group-hover:ring-electric-400/60 transition-all shadow-glow-sm">
            <Image src="/logo.png" alt="Crypto Credits" fill className="object-cover scale-[1.35]" priority />
          </div>
          <div className="leading-none">
            <span className="block font-display font-bold tracking-wide text-[15px] text-chrome">
              CRYPTO CREDITS
            </span>
            <span className="block text-[9px] tracking-[0.35em] text-electric-400/80 mt-1">
              DIGITAL ASSET LENDING
            </span>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-steel-300 hover:text-white transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-electric-400 hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            href="/login"
            className="px-4 py-2 text-sm font-medium text-steel-200 hover:text-white transition-colors"
          >
            Sign in
          </Link>
          <Link
            href="/register"
            className="btn-shimmer px-5 py-2.5 text-sm font-semibold rounded-lg bg-gradient-to-b from-electric-400 to-electric-600 text-white shadow-glow hover:shadow-glow-lg transition-shadow"
          >
            Get a loan
          </Link>
        </div>

        <button
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg glass text-steel-100"
          aria-label="Menu"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            {open ? (
              <path strokeLinecap="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-ink/95 backdrop-blur-xl border-b border-steel-700/40"
          >
            <div className="px-6 py-5 flex flex-col gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-steel-200 hover:text-white transition-colors"
                >
                  {l.label}
                </a>
              ))}
              <div className="flex gap-3 pt-2">
                <Link href="/login" className="flex-1 text-center px-4 py-2.5 rounded-lg glass text-steel-100">
                  Sign in
                </Link>
                <Link
                  href="/register"
                  className="flex-1 text-center px-4 py-2.5 rounded-lg bg-gradient-to-b from-electric-400 to-electric-600 text-white font-semibold shadow-glow"
                >
                  Get a loan
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  )
}
